import { memo } from 'react';
import { AppointmentNameProps } from './AppointmentName.types';
import { BaseAppointmentName } from '../BaseAppointmentName/BaseAppointmentName';
import { useAppointmentState } from '../../../context/Appointment/appointment';

/**
 * The display name component for the appointment.
 *
 * This component uses the `BaseAppointmentName` component to render the appointment name.
 * If the `appointment` prop is not provided, it will fall back to using the appointment state from the context.
 *
 * @param appointment - {@link AppointmentNameProps.appointment appointment} description.
 * @param fullName - {@link AppointmentNameProps.fullName fullName} description. (default: false)
 * @param lastFirst - {@link AppointmentNameProps.lastFirst lastFirst} description. (default: false)
 */
const AppointmentName = memo(({
    appointment,
    fullName = false,
    lastFirst = false,
}: AppointmentNameProps) => {
    const stateAppointment = useAppointmentState();

    return (
        <BaseAppointmentName
            appointment={appointment ? appointment : stateAppointment}
            fullName={fullName}
            lastFirst={lastFirst}
        />
    );
});

export default AppointmentName;